import {Button, closeDialog, Label, openDialog, Tooltip} from 'platform/components';
import {HStack, Icon, Show, VStack} from 'platform/foundation';

import {useGetTireSetLocationQuery} from '@dms/api/core';
import i18n from '@dms/i18n';

import {isNotNilOrEmpty, Nullish, RequiredTestIdProps, suffixTestId} from 'shared/web';

import {StorageWarehouseDialog} from './StorageWarehouseDialog';

interface StorageWarehouseProps extends RequiredTestIdProps {
  tireSetId?: string | Nullish;
  tireOrderId: string;
  isDisabled: boolean;
}

export function StorageWarehouse(props: StorageWarehouseProps) {
  const tireSetLocationQuery = useGetTireSetLocationQuery(
    {
      orderId: props.tireOrderId,
      setId: props.tireSetId || '',
    },
    {
      skip: !props.tireSetId || !props.tireOrderId,
    }
  );

  const tooltip = tireSetLocationQuery.data?.location
    ? `${tireSetLocationQuery.data.storageLocation?.branch?.name} / ${tireSetLocationQuery.data.storageLocation?.warehouse?.name} / ${tireSetLocationQuery.data.location}`
    : undefined;

  const storageTitle =
    tireSetLocationQuery.data?.location || i18n.t('entity.warehouse.actions.assignStorageLocation');

  return (
    <Show when={props.tireSetId}>
      <VStack align="flex-start">
        <HStack spacing={1}>
          <Label>{i18n.t('entity.warehouse.labels.storageLocation')}</Label>
          <Show when={isNotNilOrEmpty(tooltip)}>
            <Tooltip label={tooltip} hasAutoWidth>
              <Icon value="action/help" size={4} color="text.secondary" />
            </Tooltip>
          </Show>
        </HStack>
        <Button
          variant="link"
          leftIcon="custom/warehouse"
          isDisabled={props.isDisabled || false}
          title={storageTitle}
          isLoading={tireSetLocationQuery.isLoading}
          onClick={() =>
            openDialog(
              <StorageWarehouseDialog
                tireSetId={props.tireSetId}
                tireOrderId={props.tireOrderId}
                onClose={() => closeDialog('storageWarehouseDialog')}
                data-testid={suffixTestId('storageWarehouseDialog', props)}
              />,
              {
                id: 'storageWarehouseDialog',
                title: tireSetLocationQuery.data?.location
                  ? `${i18n.t('entity.warehouse.labels.assignStorageLocation')} ${i18n.t('entity.warehouse.labels.currentlyAssigned', {location: tireSetLocationQuery.data?.location})}`
                  : i18n.t('entity.warehouse.labels.assignStorageLocation'),
                size: 'large',
              }
            )
          }
          data-testid={suffixTestId('storageWarehouse', props)}
        />
      </VStack>
    </Show>
  );
}
